<template>
  <div class="row">
      <div class="col-12 question-card">
        <div class="card mt-2">
          <div class="card-header" style="color: darkcyan; background-color: rgba(20,141,147,0.25); text-align: left;">
              <strong style="font-size: 25px">Data {{index}} / {{annotation.number_of_questions}}</strong>
              <button type="button"
                      class="btn btn-info"
                      v-on:click="pass_problem"
                      aria-label="Notice) If you press the button, all the contents of the problem will be initialized, so be careful."
                      data-balloon-pos="up"
                      data-balloon-length="large"
                      style="float:right; background-color:yellowgreen; color: white; font-size: 18px; border: none">
                <B>{{this.pass_msg}}</B>
              </button>
          </div>
          <div v-if="annotation.passed" style="font-size: 18px; color: green; text-align: left; margin-left: 40px; margin-right:40px;">
            <br/>
            <B> This problem was passed. (will not be payed)</B><br/>
            <v-textarea
              v-model="annotation.pass_reason"
              placeholder="Why do you pass this problem? (You must feel this blank)"
              outlined
              rows="3"/>
            <br/>
          </div>
          <div v-if="!annotation.passed" class="card-body" style="text-align: left">
            <div id="provided">
              <strong style="font-size: 18px; float: left; margin-right: 10px;">Preliminary Data</strong>
              <span
                  class="material-icons"
                  style="font-size: 24px;"
                  data-balloon-pos="right"
                  data-balloon-length="large"
                  aria-label="If the preliminary data is wrong or not plausible, you can amend provided data anytime."
              > help_outline
              </span><br/><br/>
              <li style="margin-left: 20px; margin-top: 20px; float: left; font-size: 18px;"><strong>Question</strong> : </li>
              <div class="d-flex col-10">
                <v-textarea
                    v-if="annotation.question.length <= 80"
                    v-model="annotation.question"
                    rows="1"/>
                <v-textarea
                    v-else-if="annotation.question.length > 80"
                    v-model="annotation.question"
                    rows="2"/>
                <v-btn
                    v-if="annotation.question.length <= 80"
                    style="background-color: white; margin-top: 10px;"
                    depressed
                    v-on:click="this.reset_question"
                    aria-label="You can return the Question to its original state."
                    data-balloon-pos="right"
                    data-balloon-length="large"
                >
                  <i class="material-icons">restart_alt</i>
                </v-btn>
                <v-btn
                    v-else-if="annotation.question.length > 80"
                    style="background-color: white; margin-top: 30px;"
                    depressed
                    v-on:click="this.reset_question"
                    aria-label="You can return the Question to its original state."
                    data-balloon-pos="right"
                    data-balloon-length="large"
                >
                  <i class="material-icons">restart_alt</i>
                </v-btn>
              </div>
              <li style="margin-left: 20px; margin-top: 15px; float: left; font-size: 18px;"><strong>Correct</strong> :&nbsp;</li>
              <div class="d-flex col-10">
                <v-textarea
                    v-if="annotation.correct.length <= 80"
                    v-model="annotation.correct"
                    rows="1"/>
                <v-textarea
                    v-else-if="annotation.correct.length <= 160"
                    v-model="annotation.correct"
                    rows="2"/>
                <v-textarea
                    v-else-if="annotation.correct.length > 160"
                    v-model="annotation.correct"
                    rows="3"/>

                <v-btn
                    v-if="annotation.correct.length <= 80"
                    style="background-color: white; margin-top: 10px;"
                    depressed
                    v-on:click="this.reset_correct"
                    aria-label="You can return the Correct to its original state."
                    data-balloon-pos="right"
                    data-balloon-length="large"
                >
                  <i class="material-icons">restart_alt</i>
                </v-btn>
                <v-btn
                    v-else-if="annotation.correct.length <= 160"
                    style="background-color: white; margin-top: 30px;"
                    depressed
                    v-on:click="this.reset_correct"
                    aria-label="You can return the Correct to its original state."
                    data-balloon-pos="right"
                    data-balloon-length="large"
                >
                  <i class="material-icons">restart_alt</i>
                </v-btn>
                <v-btn
                    v-else-if="annotation.correct.length > 160"
                    style="background-color: white; margin-top: 50px;"
                    depressed
                    v-on:click="this.reset_correct"
                    aria-label="You can return the Correct to its original state."
                    data-balloon-pos="right"
                    data-balloon-length="large"
                >
                  <i class="material-icons">restart_alt</i>
                </v-btn>
              </div>
            </div>
            <v-divider></v-divider>
            <div id="step_1">
              <strong style="font-size: 25px; margin-left: 5px;"> [STEP 1] &nbsp; Data creation</strong>
              <div style="margin-left: 10px; margin-top: 15px; margin-bottom: 5px; font-size: 18px;"><strong>1. Create an Incorrect </strong></div>
              <span style="margin-left: 20px;">Modify the existing Correct to create an Incorrect of the question.</span><br/>
              <div id="make_incorrect" class="d-flex" style="max-width: 1000px; margin-left: 20px; margin-top: 5px;">
                  <v-text-field
                      v-model="annotation.incorrect"
                      hint="create a wrong answer for question."
                      outlined
                      clearable
                      label="Incorrect"
                      type="text"
                      style="max-width: 1000px;"
                ></v-text-field>
                <v-btn
                    style="background-color: white; margin-top: 10px;"
                    depressed
                    v-on:click="this.reset_incorrect"
                    aria-label="Clear all."
                    data-balloon-pos="right"
                >
                  <i class="material-icons">restart_alt</i>
                </v-btn>
              </div>
              <table style="margin-left: 20px;">
                <tbody>
                  <tr style="background-color: #ffe8de; border-bottom: 2px solid darkgrey;">
                    <td style="width: 120px; text-align: center;">Question</td>
                    <td style="width: 380px; max-width: 815px; padding-left: 10px;"> {{annotation.question}} </td>
                  </tr>
                  <tr style="background-color: white">
                    <td style="text-align: center;">Correct</td>
                    <td style="padding-left: 10px; max-width: 815px;"> {{annotation.correct}} </td>
                  </tr>
                  <tr style="background-color: white">
                    <td style="text-align: center;">Incorrect</td>
                    <td style="padding-left: 10px; width: 815px; max-width: 815px;"> {{annotation.incorrect}} </td>
                  </tr>
                </tbody>
              </table>
              <br/>

              <div id="make_question"
                   style="margin-left: 10px; margin-top: 15px; margin-bottom: 5px; font-size: 18px;">
                <strong>2. Create a New Question </strong>
              </div>
              <span style="margin-left: 20px;">Construct a question with 'Incorrect' in Part 1 by treating it as 'Correct'.</span><br/>
              <div class="d-flex" style="max-width: 1000px; margin-left: 20px; margin-top: 5px;">
                <v-text-field
                v-model="annotation.new_question"
                hint="create a new question."
                outlined
                clearable
                label="New Question"
                type="text"
                ></v-text-field>
                <v-btn
                    style="background-color: white; margin-top: 10px;"
                    depressed
                    v-on:click="this.reset_new_question"
                    aria-label="Clear all."
                    data-balloon-pos="right"
                ><i class="material-icons">restart_alt</i></v-btn>
              </div>
              <table style="margin-left: 20px;">
                <tbody>
                  <tr style="background-color: #e2efff; border-bottom: 2px solid darkgrey;">
                    <td style="width: 120px; text-align: center;">New Question</td>
                    <td style="width: 815px; max-width: 815px; padding-left: 10px;"> {{annotation.new_question}} </td>
                  </tr>
                  <tr style="background-color: white">
                    <td style="text-align: center;">Correct</td>
                    <td style="padding-left: 10px; max-width: 815px;"> {{annotation.incorrect}} </td>
                  </tr>
                  <tr style="background-color: white">
                    <td style="text-align: center;">Incorrect</td>
                    <td style="padding-left: 10px; max-width: 815px;"> {{annotation.correct}} </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br/>
            <v-divider></v-divider>
            <div id="step_2">
              <strong style="font-size: 25px; margin-left: 5px; float:left; margin-right:10px;"> [STEP 2] &nbsp; Data validation</strong>
              <span
                  class="material-icons"
                  style="font-size: 24px; margin-top: 5px;"
                  data-balloon-pos="up"
                  data-balloon-length="xlarge"
                  aria-label="To submit your responses, you should confirm all the check boxes below. If you cannot agree with the contents below, you must regenerate the data."
              > help_outline
              </span><br>

              <div style="margin-left: 10px; margin-top: 20px; font-size: 16px; margin-bottom: 30px;">
                <strong>With the following criteria, review two QA Data by checking the box on the left, otherwise further edition is needed.</strong><br/>
                <span style="color: mediumvioletred">(The Colored Words may be hints that only appear in one-side. Please correct it if you think that wording could be a big hint about the goal. You can amend the data you created, or you can edit the preliminary data we provided.)</span>
              </div>

              <div style="margin-top: 15px;">
                <strong style="margin-left: 15px; font-size: 18px; float:left">QA Data 1</strong>
                <strong style="font-size: 18px; float:left; margin-left: 435px;">QA Data 2</strong>
              </div>
              <br/>
              <div class="d-flex" style="margin-top: 3px;">
                <table style="margin-top: 5px; float: left; margin-left: 10px">
                  <tbody>
                    <tr style="background-color: #ffe8de; border-bottom: 2px solid darkgrey;">
                      <td style="width: 120px; text-align: center;">Question</td>
                      <td style="width: 380px; padding-left: 10px;" v-html="painting[0]"></td>
                    </tr>
                    <tr style="background-color: white">
                      <td style="text-align: center;">Correct</td>
                      <td style="padding-left: 10px; max-width: 380px;"  v-html="painting[1]"></td>
                    </tr>
                    <tr style="background-color: white">
                      <td style="text-align: center;">Incorrect</td>
                      <td style="padding-left: 10px; max-width: 380px;" v-html="painting[2]"></td>
                    </tr>
                  </tbody>
                </table>
                <table style="margin-left: 20px; margin-top: 5px; float: left">
                  <tbody>
                    <tr style="background-color: #e2efff; border-bottom: 2px solid darkgrey;">
                      <td style="width: 120px; text-align: center;">New Question</td>
                      <td style="width: 380px; padding-left: 10px;" v-html="painting[3]"> </td>
                    </tr>
                    <tr style="background-color: white">
                      <td style="text-align: center;">Correct</td>
                      <td style="padding-left: 10px; max-width: 380px;" v-html="painting[4]"> </td>
                    </tr>
                    <tr style="background-color: white">
                      <td style="text-align: center;">Incorrect</td>
                      <td style="padding-left: 10px; max-width: 380px;" v-html="painting[5]"></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div id="input boxes" style="margin-top: 15px; margin-left: 20px;">
                <div style="margin-bottom:5px; font-size: 18px;">
                  <strong>In QA Data1,</strong><br/>
                </div>
                <div>
                  <input type="checkbox"
                         v-bind:name="'first-' + index"
                         v-bind:value="'first-' + index"
                         v-model="annotation.val1"
                         style="margin-right: 10px;"
                         :id="'first-' + index"/>
                  <label :for="'first-' + index">The correct answer <U>can be clearly distinguished</U> from the Incorrect.</label>
                  <br/>
                  <input type="checkbox"
                         v-bind:name="'second-' + index"
                         v-bind:value="'second-' + index"
                         v-model="annotation.val2"
                         style="margin-right: 10px;"
                         :id="'second-' + index"/>
                  <label :for="'second-' + index">Specific wordings to the Question are <U> mentioned only</U> in 1) Both Correct and Incorrect OR 2) Neither Correct nor Incorrect. &nbsp;&nbsp;&nbsp;&nbsp;</label><br/>
                </div>

                <div style="margin-bottom:5px; margin-top: 10px; font-size: 18px;">
                  <strong>In QA Data2,</strong><br/>
                </div>
                <div>
                  <input type="checkbox"
                         v-bind:name="'third-' + index"
                         v-bind:value="'third-' + index"
                         v-model="annotation.val3"
                         style="margin-right: 10px;"
                         :id="'third-' + index"/>
                  <label :for="'third-' + index">The correct answer <U>can be clearly distinguished</U> from the Incorrect.</label>
                  <br/>
                  <input type="checkbox"
                         v-bind:name="'forth-' + index"
                         v-bind:value="'forth-' + index"
                         v-model="annotation.val4"
                         style="margin-right: 10px;"
                         :id="'forth-' + index"/>
                  <label :for="'forth-' + index">Specific wordings to the Question are <U> mentioned only</U> in 1) Both Correct and Incorrect OR 2) Neither Correct nor Incorrect.</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br/>
      </div>
  </div>
</template>


<script>
export default {
  name: 'Question',
  data(){
    return{
      temp_question: this.annotation.question,
      temp_correct: this.annotation.correct,
      msg: "pass",

      stop_words:
            ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
              'the', 'for', 'in', 'of', "'s", 'my', 'me', 'you', 'are', 'is', 'were', 'was', 'be', "your", "an", "as", "for", "from",
              "i'm", "you're", 'it', ",", ".", "'ve", "we", "them", "they", "we've", "at", "such", "him", "her", "at", "their", "my", "on",
              "they're", "we'll", "i'll", "you'll", "he'll", "she'll", "it's", "its", "do", "so", "to", "and", "she", "he", "on", "into", "make",
              "with", "when", "why", "how", "what", "while", "can", "about", "take"],

      paint_data0: '',
      paint_data1: '',
      paint_data2: '',
      paint_data00: '',
      paint_data11: '',
      paint_data22: '',
    }
  },

  props: {
    annotation: {
      type: Object,
      required: true,
    },
    index: {
      type: String,
      required: true,
    },
  },

  methods:{
    reset_question(){
      this.annotation.question = this.temp_question
    },
    reset_correct(){
      this.annotation.correct = this.temp_correct
    },
    reset_incorrect(){
      this.annotation.incorrect = ''
    },
    reset_new_question(){
      this.annotation.new_question = ''
    },
    pass_problem(){
      this.annotation.passed = !this.annotation.passed
    }
  },

  computed:{
    pass_msg() {
      let message = ""
      if (this.annotation.passed === true){
        message = "return"
      }
      else{
        message = "pass"
      }
      return message
    },
    painting: function() {
      let results = [];

      let question;
      let sen1;
      let sen2;

      question = this.annotation.question;
      sen1 = this.annotation.correct;
      sen2 = this.annotation.incorrect;

      let words = question.split(' ');
      let sen1_words = sen1.split(' ');
      let sen2_words = sen2.split(' ');

      let words_low = words.map(sen => sen.toLowerCase())
      let sen1_words_low = sen1_words.map(sen => sen.toLowerCase())
      let sen2_words_low = sen2_words.map(sen => sen.toLowerCase())

      let sen_len = words.length;

      // paint question
      let only_sen1 = [];
      let only_sen2 = [];
      let new_que = '';
      for (let i=0; i<sen_len; i++){
        let last = ''
        if ((i === sen_len-1) && ['.', ',', '?', '!', '"', "'", '~', ';', '>'].includes(words_low[i].slice(-1))){
          last = words_low[i].slice(-1)
          words_low[i] = words_low[i].slice(0, -1)
          words[i] = words[i].slice(0, -1)
        }

        if (sen1.toLowerCase().indexOf(words_low[i]) !== -1 && sen2.toLowerCase().indexOf(words_low[i]) === -1 && !this.stop_words.includes(words_low[i])){
          only_sen1.push(words[i].toLowerCase())
          new_que = new_que.concat('&nbsp;', '<i style="color: red">', words[i], '</i>', last,'&nbsp;')
        }
        else{
          if (sen2.toLowerCase().indexOf(words_low[i]) !== -1 && sen1.toLowerCase().indexOf(words_low[i]) === -1 && !this.stop_words.includes(words_low[i])){
            only_sen2.push(words[i].toLowerCase())
            new_que = new_que.concat('&nbsp;', '<i style="color: blue">', words[i], '</i>', last, '&nbsp;')
          }
          else{
            new_que = new_que.concat(' ', words[i])
          }
        }
      }

      // paint sentence1
      let new_sen1 = '';
      for (let i=0; i < sen1_words_low.length; i++){
        if (only_sen1.length !== 0){
          let cnt = 0;
          for (let j=0; j < only_sen1.length; j++){
            if (sen1_words_low[i].indexOf(only_sen1[j]) !== -1){
              new_sen1 = new_sen1.concat('&nbsp;', '<i style="color: red">', sen1_words[i], '</i>', '&nbsp;')
              break
            }
            else{
              cnt += 1;
            }
            if (cnt === only_sen1.length){
                new_sen1 = new_sen1.concat(' ', sen1_words[i])
            }
          }
        }
        else{
          new_sen1 = new_sen1.concat(' ', sen1_words[i])
        }
      }

      // paint sentence2
      let new_sen2 = '';
      for (let i=0; i < sen2_words_low.length; i++){
        if (only_sen2.length !== 0){
          let cnt = 0;
          for (let j=0; j < only_sen2.length; j++){
            if (sen2_words_low[i].indexOf(only_sen2[j]) !== -1){
              new_sen2 = new_sen2.concat('&nbsp;', '<i style="color: blue">', sen2_words[i], '</i>', '&nbsp;')
              break
            }
            else{
              cnt += 1;
            }
            if (cnt === only_sen2.length){
                new_sen2 = new_sen2.concat(' ', sen2_words[i])
            }
          }
        }
        else{
          new_sen2 = new_sen2.concat(' ', sen2_words[i])
        }
      }

      var dom = document.createElement('div');
      dom.innerHTML = new_que;
      // this.paint_data0 = dom.innerHTML;
      results.push(dom.innerHTML)
      dom.innerHTML = new_sen1;
      // this.paint_data1 = dom.innerHTML;
      results.push(dom.innerHTML)
      dom.innerHTML = new_sen2;
      // this.paint_data2 = dom.innerHTML;
      results.push(dom.innerHTML)



      //////////////////////////////////////////////////////////////////////
      /////////////////////////// for QA DATA 2 ////////////////////////////
      //////////////////////////////////////////////////////////////////////
      question = this.annotation.new_question;
      sen1 = this.annotation.incorrect;
      sen2 = this.annotation.correct;

      words = question.split(' ');
      sen1_words = sen1.split(' ');
      sen2_words = sen2.split(' ');

      words_low = words.map(sen => sen.toLowerCase())
      sen1_words_low = sen1_words.map(sen => sen.toLowerCase())
      sen2_words_low = sen2_words.map(sen => sen.toLowerCase())

      sen_len = words.length;

      // paint question
      only_sen1 = [];
      only_sen2 = [];
      new_que = '';
      for (let i=0; i<sen_len; i++){
        let last = ''
        if ((i === sen_len-1) && ['.', ',', '?', '!', '"', "'", '~', ';', '>'].includes(words_low[i].slice(-1))){
          last = words_low[i].slice(-1)
          words_low[i] = words_low[i].slice(0, -1)
          words[i] = words[i].slice(0, -1)
        }

        if (sen1.toLowerCase().indexOf(words_low[i]) !== -1 && sen2.toLowerCase().indexOf(words_low[i]) === -1 && !this.stop_words.includes(words_low[i])){
          only_sen1.push(words[i].toLowerCase())
          new_que = new_que.concat('&nbsp;', '<i style="color: red">', words[i], '</i>', last,'&nbsp;')
        }
        else{
          if (sen2.toLowerCase().indexOf(words_low[i]) !== -1 && sen1.toLowerCase().indexOf(words_low[i]) === -1 && !this.stop_words.includes(words_low[i])){
            only_sen2.push(words[i].toLowerCase())
            new_que = new_que.concat('&nbsp;', '<i style="color: blue">', words[i], '</i>', last, '&nbsp;')
          }
          else{
            new_que = new_que.concat(' ', words[i])
          }
        }
      }

      // paint sentence1
      new_sen1 = '';
      for (let i=0; i < sen1_words_low.length; i++){
        if (only_sen1.length !== 0){
          let cnt = 0;
          for (let j=0; j < only_sen1.length; j++){
            if (sen1_words_low[i].indexOf(only_sen1[j]) !== -1){
              new_sen1 = new_sen1.concat('&nbsp;', '<i style="color: red">', sen1_words[i], '</i>', '&nbsp;')
              break
            }
            else{
              cnt += 1;
            }
            if (cnt === only_sen1.length){
                new_sen1 = new_sen1.concat(' ', sen1_words[i])
            }
          }
        }
        else{
          new_sen1 = new_sen1.concat(' ', sen1_words[i])
        }
      }

      // paint sentence2
      new_sen2 = '';
      for (let i=0; i < sen2_words_low.length; i++){
        if (only_sen2.length !== 0){
          let cnt = 0;
          for (let j=0; j < only_sen2.length; j++){
            if (sen2_words_low[i].indexOf(only_sen2[j]) !== -1){
              new_sen2 = new_sen2.concat('&nbsp;', '<i style="color: blue">', sen2_words[i], '</i>', '&nbsp;')
              break
            }
            else{
              cnt += 1;
            }
            if (cnt === only_sen2.length){
                new_sen2 = new_sen2.concat(' ', sen2_words[i])
            }
          }
        }
        else{
          new_sen2 = new_sen2.concat(' ', sen2_words[i])
        }
      }


      dom = document.createElement('div');
      dom.innerHTML = new_que;
      // this.paint_data00 = dom.innerHTML;
      results.push(dom.innerHTML)
      dom.innerHTML = new_sen1;
      // this.paint_data11 = dom.innerHTML;
      results.push(dom.innerHTML)
      dom.innerHTML = new_sen2;
      // this.paint_data22 = dom.innerHTML;
      results.push(dom.innerHTML)

      return results
    },

    show_paint0() {
      return this.paint_data0
    },
  },

  watch: {
    annotation() {
      this.$emit('input', this.annotation);
    }
  },

}
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card{
  border-color: darkcyan;
  border-style: solid;
  border-width: 2px;
}


</style>
